// eslint-disable-next-line import/no-restricted-paths
import isEqual from "lodash.isequal";

import { nullableValueToNull } from "@/lib/chillnn/nullable-value-to-null";

import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

/**
 *
 * @description 深い比較（Deep Comparison）を行う
 *
 */
export const confirmIsDirty = <I, E, Q>(
	currentInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	initInput?: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
): boolean => {
	// 再帰的にnullableな値をnullに変換（undefined, null を今回の比較では同じものとして扱うため）
	const convertedCurrentInput = nullableValueToNull(currentInput);
	const convertedInitInput = nullableValueToNull(initInput);

	return initInput ? !isEqual(convertedCurrentInput, convertedInitInput) : false;
};
